import React from 'react';
import {Link} from 'react-router-dom';


class LandingPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showLandingPage: true
        };

        this.closeLandingPage = this.closeLandingPage.bind(this);
    }

    closeLandingPage() {
        this.props.onCloseLandingPage();
        this.setState({
            showLandingPage: false
        });
    }

    render() {
        return (
            <div id="landing-page-wrapper">
                <h1 className="page-title">Coronavirus <br/>Trivia Game</h1>
                <p>This game will test your knowledge of the internationally popular pandemic. <br/>The goal of the
                    game is to entertain, educate, and inform!
                </p>
                <Link className="btn btn-default play-game-btn" to="/game">PLAY THE GAME</Link>
            </div>
        );

    }
}

export default LandingPage;
